export const GET_HARYANA_RECORDS_REQUEST = 'GET_HARYANA_RECORDS_REQUEST';
export const GET_HARYANA_RECORDS_SUCCESS = 'GET_HARYANA_RECORDS_SUCCESS';
export const GET_HARYANA_RECORDS_FAIL = 'GET_HARYANA_RECORDS_FAIL';
export const GET_HARYANA_RECORDS_RESET = 'GET_HARYANA_RECORDS_RESET';

export const CREATE_HARYANA_RECORD_REQUEST = 'CREATE_HARYANA_RECORD_REQUEST';
export const CREATE_HARYANA_RECORD_SUCCESS = 'CREATE_HARYANA_RECORD_SUCCESS';
export const CREATE_HARYANA_RECORD_FAIL = 'CREATE_HARYANA_RECORD_FAIL';
export const CREATE_HARYANA_RECORD_RESET = 'CREATE_HARYANA_RECORD_RESET';

export const UPDATE_HARYANA_RECORD_REQUEST = 'UPDATE_HARYANA_RECORD_REQUEST';
export const UPDATE_HARYANA_RECORD_SUCCESS = 'UPDATE_HARYANA_RECORD_SUCCESS';
export const UPDATE_HARYANA_RECORD_FAIL = 'UPDATE_HARYANA_RECORD_FAIL';
export const UPDATE_HARYANA_RECORD_RESET = 'UPDATE_HARYANA_RECORD_RESET';

export const DELETE_HARYANA_RECORD_REQUEST = 'DELETE_HARYANA_RECORD_REQUEST';
export const DELETE_HARYANA_RECORD_SUCCESS = 'DELETE_HARYANA_RECORD_SUCCESS';
export const DELETE_HARYANA_RECORD_FAIL = 'DELETE_HARYANA_RECORD_FAIL';
export const DELETE_HARYANA_RECORD_RESET = 'DELETE_HARYANA_RECORD_RESET';

export const BULK_DELETE_HARYANA_RECORDS_REQUEST = 'BULK_DELETE_HARYANA_RECORDS_REQUEST';
export const BULK_DELETE_HARYANA_RECORDS_SUCCESS = 'BULK_DELETE_HARYANA_RECORDS_SUCCESS';
export const BULK_DELETE_HARYANA_RECORDS_FAIL = 'BULK_DELETE_HARYANA_RECORDS_FAIL';
export const BULK_DELETE_HARYANA_RECORDS_RESET = 'BULK_DELETE_HARYANA_RECORDS_RESET';

export const IMPORT_HARYANA_RECORDS_REQUEST = 'IMPORT_HARYANA_RECORDS_REQUEST';
export const IMPORT_HARYANA_RECORDS_SUCCESS = 'IMPORT_HARYANA_RECORDS_SUCCESS';
export const IMPORT_HARYANA_RECORDS_FAIL = 'IMPORT_HARYANA_RECORDS_FAIL';
export const IMPORT_HARYANA_RECORDS_RESET = 'IMPORT_HARYANA_RECORDS_RESET';

export const EXPORT_HARYANA_RECORDS_REQUEST = 'EXPORT_HARYANA_RECORDS_REQUEST';
export const EXPORT_HARYANA_RECORDS_SUCCESS = 'EXPORT_HARYANA_RECORDS_SUCCESS';
export const EXPORT_HARYANA_RECORDS_FAIL = 'EXPORT_HARYANA_RECORDS_FAIL';
export const EXPORT_HARYANA_RECORDS_RESET = 'EXPORT_HARYANA_RECORDS_RESET';

// Add these new constants at the end of the file
export const SYNC_HARYANA_TASK_STATUS_REQUEST = 'SYNC_HARYANA_TASK_STATUS_REQUEST';
export const SYNC_HARYANA_TASK_STATUS_SUCCESS = 'SYNC_HARYANA_TASK_STATUS_SUCCESS';
export const SYNC_HARYANA_TASK_STATUS_FAIL = 'SYNC_HARYANA_TASK_STATUS_FAIL';
export const SYNC_HARYANA_TASK_STATUS_RESET = 'SYNC_HARYANA_TASK_STATUS_RESET';